export default "__VITE_ASSET__DHN4BL7F__"